import { cn } from "src/lib";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-border-light", className)}
      {...props}
    />
  );
}

export { Skeleton };
